// Several email addresses on one account (OpenSpec 126). The server lists them, checks the
// proof of ownership, and sends the confirm links. This file holds the types and the small
// helpers the Settings card and the confirm page share.

/** Where a fresh sign-in returns to, so the user lands back on the address list. */
export const EMAILS_RETURN_PATH = '/dashboard/settings?tab=profile'

/** One sentence for the places that tell a free user how to get past the work-email rule. */
export const WORK_EMAIL_FIX = 'Signed up with another address? Add a work email address in Settings.'

export type ReauthMethod = 'password' | 'google' | 'github' | 'magic_link'

export type AccountEmails = {
  primary: { email: string; confirmed: boolean }
  emails: { id: string; email: string; confirmed: boolean }[]
  limit: number
}

const METHODS: readonly string[] = ['password', 'google', 'github', 'magic_link']

/** The sign-in method the server asks for (`reauth_required`), or null for any other error. */
export function reauthMethodOf(err: unknown): ReauthMethod | null {
  const e = err as { code?: unknown; details?: unknown } | null
  if (!e || e.code !== 'reauth_required') return null
  const method = (e.details as { method?: unknown } | undefined)?.method
  return typeof method === 'string' && METHODS.includes(method) ? (method as ReauthMethod) : null
}

/** The API link that starts a fresh Google or GitHub sign-in and returns to Settings. */
export function oauthReauthUrl(provider: 'google' | 'github', apiUrl: string, returnPath = EMAILS_RETURN_PATH): string {
  const params = new URLSearchParams({ reauth: '1', redirect: returnPath })
  return `${apiUrl}/auth/${provider}?${params.toString()}`
}
